import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { sorted } from "../../utils";

export function HomeProductions({ siteContent }) {
  const images = siteContent?.image;
  const videos = siteContent?.video
  const productions = siteContent?.production
  const history = useHistory();

  const replaceUrl = (value) => {
    const url = value.replace("watch?v=", "embed/")
    const id = url.split("https://www.youtube.com/embed/")

    return {
      id: id[1],
      url
    }
  }


  const PHOTOS = images
  const VIDEOS = videos
  const PRODUCTIONS = productions

  const top2Photos = useMemo(() => {
    const sort = sorted(PHOTOS, 'date');
    return sort
  }, [PHOTOS]);

  const top2Videos = useMemo(() => {
    const sort = sorted(VIDEOS, 'date');
    return sort
  }, [VIDEOS]);

  const top2Productions = useMemo(() => {
    const sort = sorted(PRODUCTIONS, 'published');
    return sort
  }, [PRODUCTIONS]);

  const openProduction = (id) => {
    // abre nova janela/aba com rota do artigo completo
    window.open(`/producoes/${id}`, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* FAIXA FOTOS */}
      <section className="section" id="fotos">
        <div className="sectionHead">
          <h2 className="section__title">FOTOS</h2>
          <button className="linkBtn" type="button" onClick={() => history.push("/fotos")}>
            Ver todas →
          </button>
        </div>

        <div className="grid grid--2">
          {top2Photos.map((p) => (
            <article className="pcard" key={p.nameFile}>
              <button className="pcard__media" type="button" onClick={(ev) => ev.preventDefault()}>
                <img src={p.nameFile} alt={p.title} loading="lazy" />
              </button>
              <div className="pcard__body">
                <div className="pcard__caption">{p.title}</div>
                <div className="pcard__meta">{p.date}</div>
                <button className="btn btn--ghost" type="button" onClick={() => history.push("/fotos")}>
                  VER GALERIA
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* FAIXA VÍDEOS */}
      <section className="section" id="videos">
        <div className="sectionHead">
          <h2 className="section__title">VÍDEOS</h2>
          <button className="linkBtn" type="button" onClick={() => history.push("/videos")}>
            Ver todos →
          </button>
        </div>

        <div className="grid grid--2">
          {top2Videos.map((v) => (
            <article className="vcard" id={replaceUrl(v.url).id} key={replaceUrl(v.url).id}>
              <div className="vcard__frame">
                <iframe
                  src={replaceUrl(v.url).url}
                  title={v.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <div className="vcard__titleRow">
                <div className="vcard__title">{v.title}</div>
                <div className="vcard__date">{v.date}</div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* FAIXA ARTIGOS */}
      {top2Productions.lenght !== 0 && (
        <section className="section" id="produções">
          <div className="sectionHead">
            <h2 className="section__title">PRODUÇÕES</h2>
            <button className="linkBtn" type="button" onClick={() => history.push("/producoes")}>
              Ver todos →
            </button>
          </div>

          <div className="grid grid--2">
            {top2Productions.map((a) => (
              <article className="acard2" key={a.id}>
                <button className="acard2__media" type="button" onClick={() => openProduction(a.id)}>
                  <img src={a.cover.url} alt={a.name} loading="lazy" />
                </button>

                <div className="acard2__body">
                  <div className="acard2__flex">
                    <div className="acard2__meta">{a.published.split("-").reverse().join("-")}</div>
                    <h3 className="acard2__title">{a.name}</h3>
                  </div>

                  <div className="acard2__actions">
                    <button className="btn btn--ghost" type="button" onClick={() => openProduction(a.id)}>
                      VISUALIZAR DOCUMENTO
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}
    </>
  );
}